import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search, ShoppingBag, Menu, X } from 'lucide-react';
import { navLinks, logoUrl } from '../../data/mock';
import { useCart } from '../../context/CartContext';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { cartCount } = useCart();

  return (
    <header className="sticky top-0 z-50">
      {/* Main Navigation - BLACK */}
      <nav className="bg-[#1a1a1a] px-4 md:px-8 py-2 md:py-4">
        <div className="max-w-[1800px] mx-auto flex items-center justify-between">
          {/* Left Nav - Desktop - NO DROPDOWN */}
          <div className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="text-white text-sm font-medium tracking-wide hover:opacity-80 transition-opacity"
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          {/* Center Logo */}
          <Link to="/" className="absolute left-1/2 transform -translate-x-1/2">
            <img
              src={logoUrl}
              alt="Yung World"
              className="h-8 md:h-16 w-auto invert"
            />
          </Link>

          {/* Right Nav - REMOVED UNITED STATES $ */}
          <div className="flex items-center gap-4">
            <Link to="/login" className="hidden md:block text-white text-sm font-medium hover:opacity-80 transition-opacity">
              LOGIN
            </Link>
            <button className="text-white hover:opacity-80 transition-opacity">
              <Search size={20} />
            </button>
            <Link to="/cart" className="relative text-white hover:opacity-80 transition-opacity" data-testid="cart-icon">
              <ShoppingBag size={20} />
              {cartCount > 0 && (
                <span className="absolute -top-2 -right-2 bg-white text-black text-xs w-5 h-5 rounded-full flex items-center justify-center font-medium" data-testid="cart-badge">
                  {cartCount}
                </span>
              )}
            </Link>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-700 pt-4">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className="block py-2 text-white text-sm font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/login" className="block py-2 text-white text-sm font-medium">
              LOGIN
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
